(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pl-age-confirmation-script"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pl-age-confirmation')) {
    customElements.define('pl-age-confirmation', class extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.group = this.closest('[data-pl-age-gate]');
        if (!this.checkbox || !this.group) return;

        this.checkbox.checked = false;
        this.onChange = () => this.sync();
        this.onPageShow = () => {
          this.checkbox.checked = false;
          this.sync();
        };
        this.onSubmit = (event) => {
          if (event.target !== this.checkbox.form || event.submitter?.name !== 'checkout') return;
          if (!this.checkbox.checked) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.checkbox.focus();
            this.checkbox.reportValidity();
          }
        };
        this.checkbox.addEventListener('change', this.onChange);
        window.addEventListener('pageshow', this.onPageShow);
        document.addEventListener('submit', this.onSubmit, true);
        this.sync();
      }

      disconnectedCallback() {
        this.checkbox?.removeEventListener('change', this.onChange);
        window.removeEventListener('pageshow', this.onPageShow);
        document.removeEventListener('submit', this.onSubmit, true);
      }

      sync() {
        const confirmed = this.checkbox.checked;
        this.group.querySelectorAll('[data-pl-age-submit]').forEach((button) => {
          button.disabled = !confirmed;
        });
        this.group.querySelectorAll('[data-pl-age-express]').forEach((buttons) => {
          buttons.hidden = !confirmed;
          buttons.inert = !confirmed;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
